/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Add_YtInputs */

const en_link_editor_add_yt = /** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add YT`)
};

const es_link_editor_add_yt = /** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir YT`)
};

const fr_link_editor_add_yt = /** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter YT`)
};

const de_link_editor_add_yt = /** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YT hinzufügen`)
};

/** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */
const ja_link_editor_add_yt = en_link_editor_add_yt;

/** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */
const zh_link_editor_add_yt = en_link_editor_add_yt;

/** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */
const ar_link_editor_add_yt = en_link_editor_add_yt;

/** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */
const id_link_editor_add_yt = en_link_editor_add_yt;

/** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */
const it_link_editor_add_yt = en_link_editor_add_yt;

/** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */
const ru_link_editor_add_yt = en_link_editor_add_yt;

/** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */
const pt_link_editor_add_yt = en_link_editor_add_yt;

/** @type {(inputs: Link_Editor_Add_YtInputs) => LocalizedString} */
const ko_link_editor_add_yt = en_link_editor_add_yt;

/**
* | output |
* | --- |
* | "Add YT" |
*
* @param {Link_Editor_Add_YtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_add_yt = /** @type {((inputs?: Link_Editor_Add_YtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Add_YtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_add_yt(inputs)
	if (locale === "es") return es_link_editor_add_yt(inputs)
	if (locale === "fr") return fr_link_editor_add_yt(inputs)
	if (locale === "de") return de_link_editor_add_yt(inputs)
	if (locale === "ja") return ja_link_editor_add_yt(inputs)
	if (locale === "zh") return zh_link_editor_add_yt(inputs)
	if (locale === "ar") return ar_link_editor_add_yt(inputs)
	if (locale === "id") return id_link_editor_add_yt(inputs)
	if (locale === "it") return it_link_editor_add_yt(inputs)
	if (locale === "ru") return ru_link_editor_add_yt(inputs)
	if (locale === "pt") return pt_link_editor_add_yt(inputs)
	return ko_link_editor_add_yt(inputs)
});